import React from 'react';
import IconFromImage from '../IconFromImage/IconFromImage';
import arrowsSrc from './assets/arrowsFavorite.svg';

const ArrowsFavoriteIcon = () => (
    <IconFromImage type="arrowsFavorite" src={arrowsSrc} />
);

export default ArrowsFavoriteIcon;
